import WidgetVideoPresentation from 'components/WidgetVideo/WidgetVideoPresentation'

export default {
  Presentation: WidgetVideoPresentation,
}
